const getRandomValues = window && window.crypto && window.crypto.getRandomValues ? () => {
  const d = new Uint32Array(4);
  window.crypto.getRandomValues(d);
  return {
    d0: d[0],
    d1: d[1],
    d2: d[2],
    d3: d[3],
  };
} : () => ({
  /* eslint-disable no-bitwise */
  d0: Math.random() * 0x100000000 >>> 0,
  d1: Math.random() * 0x100000000 >>> 0,
  d2: Math.random() * 0x100000000 >>> 0,
  d3: Math.random() * 0x100000000 >>> 0,
  /* eslint-enable no-bitwise */
});

/* eslint-disable */
/**
 * Fast UUID generator, RFC4122 version 4 compliant.
 * @author Jeff Ward (jcward.com).
 * @license MIT license
 * @link http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
 */
const lut: string[] = []; for (let i = 0; i < 256; i++) { lut[i] = (i < 16 ? '0' : '') + (i).toString(16); }
export default function (): string {
  const { d0, d1, d2, d3 } = getRandomValues();
  return `${lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff]}-${
    lut[d1 & 0xff]}${lut[d1 >> 8 & 0xff]}-${lut[d1 >> 16 & 0x0f | 0x40]}${lut[d1 >> 24 & 0xff]}-${
    lut[d2 & 0x3f | 0x80]}${lut[d2 >> 8 & 0xff]}-${lut[d2 >> 16 & 0xff]}${lut[d2 >> 24 & 0xff]
  }${lut[d3 & 0xff]}${lut[d3 >> 8 & 0xff]}${lut[d3 >> 16 & 0xff]}${lut[d3 >> 24 & 0xff]}`;
};
